import { CLOUDFLARE_ORIGIN_ERROR_STATUSES } from './media-vault-error';

export function isCloudflareOriginErrorStatus(status: number): boolean {
  return CLOUDFLARE_ORIGIN_ERROR_STATUSES.includes(status);
}
